import Button from 'components/formElements/Button'
import DefaultSelect from 'components/formElements/DefaultSelect'
import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import { useRequest } from 'hooks/useRequest'
import useToast from 'hooks/useToast'
import moment from 'moment'
import {Calendar} from 'primereact/calendar'
import {useState, useEffect} from 'react'
import Loading from 'components/loader/Loading'
import { useParams } from 'react-router-dom'
import AccordionComp from 'components/accordion/Accordion'
import {DataTable} from 'primereact/datatable'
import {ColumnGroup} from 'primereact/columngroup'
import {Row} from 'primereact/row'
import {Column} from 'primereact/column'
const EffortAnalysis = () => {
	const { projectId } = useParams()
	const [getDevelopers] = useRequest()
	const [getReport, getReportLoading] = useRequest()
	const [developers, setDevelopers] = useState()
	const { showToast } = useToast()
	const [report, setReport] = useState({
		devSummaries: [],
		projectSummaries: [],
	})
	const [requestBody, setRequestBody] = useState({
		startDate: moment().subtract(1, 'months').toISOString(),
		endDate: moment().toISOString(),
		developerId: null,
	})
	useEffect(() => {
		getDevelopers('/Developer/GetAllDevelopers', { method: 'GET' }).then((res) => {
			if (res.data.ok) {
				setDevelopers(
					res?.data?.result
						?.sort(function (a, b) {
							return a.fullName.localeCompare(b.fullName)
						})
						?.map((p) => ({ label: p.fullName, value: p.id }))
				)
			}
		})
		if (projectId) {
			setRequestBody((prev) => ({ ...prev, projectId: projectId }))
		}
	}, [])
	const handleChange = (e) => {
		console.log(e)
		setRequestBody((prev) => ({ ...prev, [e.name]: e.value }))
	}
	const handleSubmit = () => {
		if (!requestBody.endDate || !requestBody.startDate) {
			showToast('Lütfen Başlangıç Tarihi ve Bitiş Tarihi Alanlarını Doldurun', 'error')
		} else {
			getReport('/Tempo/Report2', {
				method: 'POST',
				data: requestBody,
			}).then((res) => {
				if (res.data.ok) {
					setReport(res.data.result)
				}
			})
		}
	}
	const calculatedTotalHour = (objectProp) => {
		return Math.round(
			report?.devSummaries?.reduce((accumulator, object) => {
				return accumulator + object[objectProp]
			}, 0) * 100
		) / 100
	}
	return (
		<AnimatedSpan className='page-container d-flex flex-column gap-4'>
			<div className='card'>
				<div className='row-margin-x'>
					<div className='col-md-8'>
						<div className='row'>
							<div className='col-md-3'>
								<Calendar
									dateFormat='dd/mm/yy'
									placeholder='Başlangıç Tarihi'
									value={requestBody.startDate && new Date(requestBody.startDate)}
									name='startDate'
									onChange={(e) => {
										handleChange({ name: e.target.name, value: moment(e.target.value).add(3, 'hours').toISOString() })
									}}
								/>
							</div>
							<div className='col-md-3'>
								<Calendar
									dateFormat='dd/mm/yy'
									placeholder='Bitiş Tarihi'
									value={requestBody.endDate && new Date(requestBody.endDate)}
									name='endDate'
									onChange={(e) => {
										handleChange({ name: e.target.name, value: moment(e.target.value).add(3, 'hours').toISOString() })
									}}
								/>
							</div>
							<div className='col-md-6'>
								<DefaultSelect
									isClearable
									isSearchable
									placeholder='Ekip Üyesi Seçiniz'
									value={developers?.find((p) => p.value == requestBody.developerId) && developers?.find((p) => p.value == requestBody.developerId)}
									selectOptions={developers}
									handleChange={(e) => handleChange({ name: 'developerId', value: e?.value ? e.value : null })}
								/>
							</div>
						</div>
					</div>
					<div className='col-md-2'>
						<Button
							disabled={getReportLoading}
							title='Raporu Al'
							handleClick={handleSubmit}
							className='btn-primary w-100 d-flex justify-content-center'
						/>
					</div>
				</div>
			</div>
			{report.devSummaries.length == 0 && report.projectSummaries.length == 0 && !getReportLoading && (
				<div className='card'>
					<div className='text-sm text-semi-bold'>Gösterilecek Bir Veri Bulunmuyor</div>
				</div>
			)}
			{getReportLoading && (
				<div className='d-flex w-100 justify-content-center'>
					<Loading size={24} />
				</div>
			)}
			<div className='row'>
				{report.devSummaries.length > 0 && (
					<AccordionComp className='report-accordion col-md-8' showHideTitle={false} onVal={false} title='Geliştiriciler'>
						<div className='row-margin-x'>
							<div className='col-md-12'>
								<DataTable
                                stripedRows
									emptyMessage='Hiç Kayıt Bulunamadı'
									responsiveLayout='stack'
									editMode='row'
									dataKey='id'
									value={report.devSummaries.sort((a,b) => a.developer.localeCompare(b.developer))}
									footerColumnGroup={
										<ColumnGroup>
											<Row>
												<Column footer='Total:' />
												<Column
													footer={() => (
														<span>
															{calculatedTotalHour('spentHours')}
															h
														</span>
													)}
												/>
												<Column
													footer={() => (
														<span>
															{calculatedTotalHour('expectedWork')}
															h
														</span>
													)}
												/>
												<Column
													footer={() => (
														<span>
															%{Math.round((calculatedTotalHour('spentHours') / calculatedTotalHour('expectedWork') * 100 ))}
														</span>
													)}
												/>
											</Row>
										</ColumnGroup>
									}
									sortField='developer' // Developer alanına göre sıralama yapılıyor
									sortOrder={1} // Artan sıralama için 1, azalan sıralama için -1
								>
									<Column
										sortable
										className='text-semi-bold text-sm'
										headerClassName='text-bold bg-primary text-default'
										field='developer'
										style={{ width: '34%' }}
										header='Developer'
									/>
									<Column
										sortable
										className='text-semi-bold text-sm'
										headerClassName='text-bold bg-primary text-default'
										field='spentHours'
										style={{ width: '22%' }}
										header='Efor'
										body={(rowData) => <span>{Math.round(rowData?.spentHours * 100) / 100}h</span>}
									/>
									<Column
										sortable
										className='text-semi-bold text-sm'
										headerClassName='text-bold bg-primary text-default'
										field='expectedWork'
										style={{ width: '22%' }}
										header='Beklenen Çalışma'
										body={(rowData) => <span>{Math.round(rowData?.expectedWork * 100) / 100}h</span>}
									/>
									<Column
										sortable
										className='text-semi-bold text-sm'
										headerClassName='text-bold bg-primary text-default'
										field='effortResult'
										style={{ width: '22%' }}
										header='Gerçekleşen / Beklenen'
										body={(rowData) => <span> %{Math.round(rowData?.effortResult * 100)}</span>}
									/>
								</DataTable>
							</div>
						</div>
					</AccordionComp>
				)}
				{report.projectSummaries.length > 0 && (
					<AccordionComp className='report-accordion col-md-4' showHideTitle={false} onVal={false} title='Projeler'>
						<div className='row-margin-x'>
							<div className='col-md-12'>
								<DataTable
                                stripedRows
									emptyMessage='Hiç Kayıt Bulunamadı'
									responsiveLayout='stack'
									editMode='row'
									dataKey='id'
									value={report.projectSummaries.sort((a,b) => a.project.localeCompare(b.project))}
									footerColumnGroup={
										<ColumnGroup>
											<Row>
												<Column footer='Total:' />
												<Column
													footer={() => (
														<span>
															{Math.round(
																report?.projectSummaries?.reduce((accumulator, object) => {
																	return accumulator + object.spentHours
																}, 0) * 100
															) / 100}
															h
														</span>
													)}
												/>
											</Row>
										</ColumnGroup>
									}
									sortField='project' // Developer alanına göre sıralama yapılıyor
									sortOrder={1} // Artan sıralama için 1, azalan sıralama için -1
								>
									<Column
										sortable
										className='text-semi-bold text-sm col-md-6'
										headerClassName='text-bold bg-primary text-default'
										field='project'
										style={{ width: '50%' }}
										header='Proje'
									/>
									<Column
										sortable
										className='text-semi-bold text-sm'
										headerClassName='text-bold bg-primary text-default'
										field='spentHours'
										style={{ width: 'auto' }}
										header='Efor'
										body={(rowData) => <span>{Math.round(rowData?.spentHours * 100) / 100}h</span>}
									/>
								</DataTable>
							</div>
						</div>
					</AccordionComp>
				)}
			</div>
		</AnimatedSpan>
	)
}

export default EffortAnalysis
